<div class="container mb-5">
        <div class="row">
          <div class="col-sm-2">
            <app-dashmenu></app-dashmenu>
          </div>
          <div class="col-sm-10">
            <div class="card">
              <div class="card-body py-4">
                <form class="row g-3 mesInfos">
                  <div class="col-md-12">
                    <h3 class="my-3 titleDevider">Vos Adresses</h3>
                  </div>
                  <div class="col-md-12">
                    <label for="adresse1" class="form-label">Adresse 1</label>
                    <input type="text" class="form-control" id="adresse1">
                  </div>
                  <div class="col-md-6">
                    <label for="ville1" class="form-label">Ville 1</label>
                    <input type="text" class="form-control" id="ville1">
                  </div>
                  <div class="col-md-6">
                    <label for="zip1" class="form-label">Code postale 1</label>
                    <input type="text" class="form-control" id="zip1">
                  </div>
                  <div class="col-md-12">
                    <label for="adresse2" class="form-label">Adresse 2</label>
                    <input type="text" class="form-control" id="adresse2">
                  </div>
                  <div class="col-md-6">
                    <label for="ville2" class="form-label">Ville 2</label>
                    <input type="text" class="form-control" id="ville2">
                  </div>
                  <div class="col-md-6">
                    <label for="zip2" class="form-label">Code postale 2</label>
                    <input type="text" class="form-control" id="zip2">
                  </div>
                  <div class="col-md-12">
                    <label for="adresse2" class="form-label">Adresse 3</label>
                    <input type="text" class="form-control" id="adresse3">
                  </div>
                  <div class="col-md-6">
                    <label for="ville3" class="form-label">Ville 3</label>
                    <input type="text" class="form-control" id="ville3">
                  </div>
                  <div class="col-md-6">
                    <label for="zip3" class="form-label">Code postale 3</label>
                    <input type="text" class="form-control" id="zip3">
                  </div>
                  <div class="col-12 text-end mt-5">
                    <button type="submit" class="btn actionBtn" style="width:auto;">Confirmer les changements</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
